(function(){"use strict";var r;try{if(typeof document<"u"){var e=document.createElement("style");e.nonce=(r=document.head.querySelector("meta[property=csp-nonce]"))==null?void 0:r.content,e.appendChild(document.createTextNode("._accordionRoot_1fwxu_1{display:flex;flex-direction:column;margin-top:-1.3rem}._accordionItem_1fwxu_7{display:flex;flex-direction:column;gap:4rem}._accordionHeader_1fwxu_13{width:100%}._accordionTrigger_1fwxu_17{border:none;outline:none;background:inherit;display:flex;align-items:center;justify-content:space-between;width:100%;gap:var(--s);color:var(--grey-800-33)}._accordionHeaderIcon_1fwxu_29{display:block;width:1rem;height:1rem}._accordionHeader_1fwxu_13[data-state=open] ._accordionHeaderIcon_1fwxu_29{transform:rotate(180deg)}._accordionContent_1fwxu_39{width:100%;box-sizing:border-box}._accordionContent_1fwxu_39[data-state=open]{animation:_slide-down_1fwxu_1 .4s ease-out,_slide-overflow_1fwxu_1 .4s forwards}._accordionContent_1fwxu_39[data-state=closed]{animation:_slide-up_1fwxu_1 .4s ease-in forwards,_slide-overflow_1fwxu_1 .4s forwards}@keyframes _slide-overflow_1fwxu_1{0%{overflow:hidden}99.99%{overflow:hidden}to{overflow:visible}}@keyframes _slide-down_1fwxu_1{0%{height:0}to{height:var(--radix-collapsible-content-height)}}@keyframes _slide-up_1fwxu_1{0%{height:var(--radix-collapsible-content-height)}to{height:0}}@media (prefers-reduced-motion){._accordionContent_1fwxu_39{transition:none;animation:none}}._collapsibleContent_ij36k_1{box-sizing:border-box}._collapsibleContent_ij36k_1[data-state=open]{animation:_slide-down_ij36k_1 .4s ease-out,_slide-overflow_ij36k_1 .4s forwards}._collapsibleContent_ij36k_1[data-state=closed]{animation:_slide-up_ij36k_1 .4s ease-in forwards,_slide-overflow_ij36k_1 .4s forwards}@keyframes _slide-overflow_ij36k_1{0%{overflow:hidden}99.99%{overflow:hidden}to{overflow:visible}}@keyframes _slide-down_ij36k_1{0%{height:0}to{height:var(--radix-collapsible-content-height)}}@keyframes _slide-up_ij36k_1{0%{height:var(--radix-collapsible-content-height)}to{height:0}}@media (prefers-reduced-motion){._collapsibleContent_ij36k_1{transition:none;animation:none}}._collapsible_9uxq6_1{border:.0625rem solid var(--grey-400-cc);padding:1rem;display:flex;flex-direction:column;background-color:var(--neutrals-white, #fff)}._collapsibleTrigger_9uxq6_9{background-color:inherit;border:none;outline:none}._collapsibleTrigger_9uxq6_9:focus-visible{outline:.125rem var(--focus-style) var(--primary-orange, #d68726);outline-offset:-.0625}._collapsible_9uxq6_1[data-disabled] ._collapsibleTrigger_9uxq6_9{cursor:auto}._collapsibleHeading_9uxq6_24{display:flex;justify-content:space-between;align-items:center}._collapsibleHeadingHead_9uxq6_30{display:flex;gap:.5rem;flex-grow:1}._collapsibleDivider_9uxq6_36{padding:1rem 0}._collapsibleIcon_9uxq6_40{color:var(--primary-red-500);width:1.5rem}._collapsibleIconArrow_9uxq6_45{color:var(--primary-red-500);width:1.25rem;height:1.25rem;transition:none;transform:none}._collapsible_9uxq6_1[data-disabled] ._collapsibleIconArrow_9uxq6_45{display:none}._collapsibleIconArrowOpened_9uxq6_57{transform:rotate(180deg)}._collapsibleHeadingHeadTitle_9uxq6_61{all:unset;width:12.125rem;display:flex;align-items:center;white-space:normal;text-align:left;flex-grow:1}._collapsibleDescription_9uxq6_71{padding:1rem 0}@media only screen and (min-width:30rem){._collapsible_9uxq6_1{background-color:inherit;padding:1.5rem 1rem}}@media only screen and (min-width:48rem){._collapsible_9uxq6_1{padding:1.5rem}}@media only screen and (min-width:64rem){._collapsible_9uxq6_1{padding:1.5rem}}@media only screen and (min-width:80rem){._collapsible_9uxq6_1{padding:2rem}}@media (prefers-reduced-motion){._collapsibleIconArrow_9uxq6_45{transition:none;animation:none}}._content_eyhl6_1{z-index:50;background-color:var(--neutrals-white);width:var(--radix-popover-trigger-width);max-height:var(--radix-popover-content-available-height)}._content_eyhl6_1[data-state=open]{animation:_slide-down_eyhl6_1 .1s ease-out}._content_eyhl6_1[data-state=closed]{animation:_slide-up_eyhl6_1 .1s ease-in}@keyframes _slide-down_eyhl6_1{0%{opacity:0;transform:scale3d(.8,.8,.8)}to{opacity:1}}@keyframes _slide-up_eyhl6_1{0%{opacity:1}to{opacity:0;transform:scale3d(.8,.8,.8)}}@media (prefers-reduced-motion){._content_eyhl6_1{transition:none;animation:none}}._skeleton_11f39_1{animation:_pulse_11f39_1 2s cubic-bezier(.4,0,.6,1) infinite;background-color:var(--grey-200-ee, #eee)}@keyframes _pulse_11f39_1{0%,to{opacity:1}50%{opacity:.5}}._visuallyHidden_7qhky_1{position:absolute;border:0;width:.065rem;height:.065rem;padding:0;margin:-.065rem;overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap;word-wrap:normal}._tabsContainer_1igt5_1{border:.0625rem solid var(--grey-300-dd);background:var(--neutrals-white);box-shadow:0 .125rem #00000012}._tabList_1igt5_7{width:100%;display:flex;justify-content:space-evenly}._tab_1igt5_1{width:inherit;background:var(--grey-200-ee);box-shadow:.0625rem 0 #0000001a inset;border:none;color:var(--grey-800-33);padding:1.125rem 1.125rem 1.375rem}._tab_1igt5_1[data-state=active]{border:none;border-top:.125rem solid var(--primary-red-500);background:var(--neutrals-white);color:var(--primary-red-500)}._tab_1igt5_1:hover{background:var(--grey-300-dd);box-shadow:.0625rem 0 #0000001a inset;color:var(--primary-red-500)}._tabTitle_1igt5_35{display:flex;justify-content:center;align-items:center;gap:.25rem}._tabText_1igt5_42{display:none}@media (min-width:48rem){._tabText_1igt5_42{display:block}}._tooltipContent_z2gl1_1{border-radius:.5rem;background:var(--grey-800-33);box-shadow:0 .25rem .375rem #ffffff40;padding:.625rem;color:var(--neutrals-white);z-index:10}._tooltipArrow_z2gl1_10{fill:var(--grey-800-33)}._tooltipTrigger_z2gl1_14{border:none;background:none}._messageBannerContainer_3mzts_1{display:flex;padding:var(--s);flex-direction:column;gap:.5rem;background-color:var(--grey-100-fa, #fafafa);border:.0625rem solid var(--grey-300-dd, #ddd);box-shadow:0 .125rem #00000012}._messageBannerHeader_3mzts_11{color:var(--primary-red-500, #d7192d);display:flex;gap:.375rem}._messageBannerDescription_3mzts_17{color:var(--grey-700-66, #666)}._messageBannerIcon_3mzts_21{width:var(--s)}._error_3mzts_25{color:var(--primary-red-500, #d7192d)}._info_3mzts_29{color:var(--neutrals-black, #000)}@media screen and (min-width: 48rem){._messageBannerContainer_3mzts_1{padding:var(--s) var(--l)}}._outerContainer_f2f7y_3{display:flex;width:100%;height:100%;align-items:center;justify-content:center}._innerContainer_f2f7y_11{position:relative;display:flex;flex-direction:column;justify-content:center;align-items:center;gap:1.5rem}._innerContainerVertical_f2f7y_20{flex-direction:row}._spinnerWrapper_f2f7y_24{position:relative;width:4rem;height:4rem}._innerContainerSmall_f2f7y_30 ._spinnerWrapper_f2f7y_24{width:1rem;height:1rem}._innerContainerMedium_f2f7y_35 ._spinnerWrapper_f2f7y_24{width:2rem;height:2rem}._spinnerContainer_f2f7y_40{position:absolute;top:0;left:50%;width:12.5rem;height:12.5rem;transform:scale(.35) translate(-50%);transform-origin:0 0}._innerContainerSmall_f2f7y_30 ._spinnerContainer_f2f7y_40{width:3rem;height:3rem}._innerContainerMedium_f2f7y_35 ._spinnerContainer_f2f7y_40{width:6rem;height:6rem}._spinnerCircle_f2f7y_60{position:absolute;top:50%;left:50%;width:0;height:0;margin:0;border-width:.5rem;border-style:solid;border-radius:50%;animation:_spinner-animation_f2f7y_1 2s ease-out infinite;opacity:0}._spinnerFirstCircle_f2f7y_74{border-color:var(--grey-700-66)}._spinnerDark_f2f7y_78{border-color:var(--neutrals-white)}._spinnerSecondCircle_f2f7y_82{border-color:var(--primary-red-500);animation-delay:1s}._spinnerText_f2f7y_87{display:block;font-family:var(--font-families-verdana);font-size:1.125rem;font-weight:700;text-align:center;color:var(--grey-700-66)}@keyframes _spinner-animation_f2f7y_1{0%{width:0;height:0;margin:0;opacity:0}33%{width:44%;height:44%;margin:-22% 0 0 -22%;opacity:1}to{width:88%;height:88%;margin:-44% 0 0 -44%;opacity:0}}@media (prefers-reduced-motion){._spinnerCircle_f2f7y_60{transition:none;animation:none}}._overlay_f9e72_1{position:absolute;top:0;left:0;width:100%;height:100%;background-color:var(--neutrals-white);display:flex;flex-direction:column;align-items:center;padding-top:4rem;z-index:10}._content_f9e72_15{text-align:center}._title_f9e72_19{font-size:1.5rem;margin-bottom:1rem;color:var(--grey-700-66)}._divider_f9e72_25{margin:1rem auto;border:none;height:.0625rem;background-color:var(--grey-400-cc);max-width:26.25rem}._subtitle_f9e72_33{font-size:1rem;margin:0;color:var(--grey-700-66)}:root{--option-rem-space-xs: .12rem;--option-rem-space-s: .5rem;--option-rem-space-m: .063rem;--option-rem-space-l: 5.75rem}._option_header_12ple_8{align-items:center;background-color:var(--grey-100-fa);display:flex;flex-direction:column;padding:var(--s) var(--xs)}._option_header_subtext_12ple_16{color:var(--grey-700-66);padding-top:var(--option-rem-space-xs)}._option_header_collapsed_12ple_21{width:100%}._option_header_text_collapsed_12ple_25{display:flex;flex-direction:column;padding-left:var(--xs);text-align:left}._option_header_subtext_collapsed_12ple_32{color:var(--grey-700-66)}._option_body_12ple_36{display:flex;flex-direction:column;height:100%;padding:var(--m)}._option_body_content_12ple_43{display:flex;align-items:baseline}._option_body_text_12ple_48{color:var(--grey-700-66);margin-bottom:var(--s);padding:var(--xxs) 0 0 var(--xs)}._option_footer_12ple_54{background-color:var(--grey-100-fa)}._option_footer_collapsed_12ple_58{padding:0 var(--m)}._option_wrapper_12ple_62{box-shadow:0 var(--xs) var(--xs) var(--grey-400-cc);display:flex;flex-direction:column;justify-content:space-between;min-height:100%}._option_not_selected_12ple_70{opacity:.6}._option_icon_container_12ple_74{display:flex;transform:translateY(.2rem)}._option_icon_12ple_74{fill:var(--primary-red-500);width:var(--s)}._option_label_12ple_84{align-items:center;display:flex;flex-direction:column}._option_label_text_12ple_90{margin:0}._option_radio_button_12ple_94{align-items:center;border-top:var(--option-rem-space-m) solid var(--grey-300-dd);display:flex!important;flex-direction:column-reverse;height:var(--option-rem-space-l);line-height:0;margin:0 var(--s);padding-bottom:var(--s)}._option_wrapper_collapsed_12ple_106{align-items:center;box-shadow:0 var(--xs) var(--xs) var(--grey-400-cc);min-height:100%}._option_collapsed_bg_12ple_112{background-color:var(--grey-100-fa);padding:var(--option-rem-space-s)}._option_label_collapsed_12ple_117{align-items:flex-end;display:flex;flex-direction:column;padding-right:var(--s);line-height:normal;width:-webkit-max-content;width:max-content}._option_radio_button_collapsed_12ple_126{align-items:center;align-self:start;line-height:0;width:100%}._option_accordion_item_12ple_133{gap:0}._card_wrapper_1g9l3_1{display:flex;gap:var(--xs);place-content:center flex-start;flex-direction:column;align-items:center;background-color:var(--neutrals-white);border-top:var(--xxs) solid var(--primary-red-500);padding:var(--s) var(--s) var(--l)}._card_icon_1g9l3_12{color:var(--primary-red-500);height:var(--font-size-10);width:var(--font-size-10)}._card_title_1g9l3_18{color:var(--primary-red-500)}:root{--size-extra-small: .0625rem;--size-small: .975rem;--size-medium: 1.25rem;--size-x-medium: .375rem;--size-large: .3rem;--size-extra-large: .25rem;--size-extra-extra-large: 1.68rem}._summary_axg1q_13,._summary_item_axg1q_14,._summary_item_children_axg1q_15{display:flex;flex-direction:column;gap:var(--s)}._summary_collapsed_axg1q_20{display:flex;flex-direction:column}._summary_item_content_axg1q_25,._summary_subitem_content_axg1q_26{display:flex;color:var(--grey-700-66);flex-direction:column;gap:var(--s);max-width:70%}._summary_back_axg1q_34{background-color:#fff;padding:1.5rem 2rem}._summary_subitem_click_axg1q_41{-webkit-text-decoration:underline!important;text-decoration:underline!important;color:var(--neutrals-black);cursor:pointer}._summary_item_body_axg1q_47{display:flex;align-items:flex-end;justify-content:space-between;color:var(--grey-700-66);padding-bottom:var(--xxs)}._summary_item_box_total_axg1q_55{display:flex;align-items:center;justify-content:space-between;border-top:var(--size-extra-small) solid var(--grey-200-ee);padding:var(--s) 0 var(--xxs)}._summary_total_axg1q_63{padding-bottom:var(--s)}._summary_icon_axg1q_67{width:var(--size-small);color:var(--primary-red-500)}._summary_icon_go_axg1q_72{rotate:90deg}._summary_icon_return_axg1q_76{rotate:-90deg}._summary_price_axg1q_80{display:flex;justify-content:space-between}._summary_subtitle_axg1q_85{color:var(--grey-700-66)}._summary_display_row_axg1q_89{display:flex;align-items:center}._summary_price_align_axg1q_94{align-self:end}._summary_text_fit_axg1q_98{max-width:70%}._summary_item_title_axg1q_102{padding-left:var(--xxs)}._summary_item_icon_children_axg1q_106{padding-left:var(--size-medium)}._summary_item_children_axg1q_15{gap:var(--size-extra-small)}._summary_subitem_title_axg1q_114{display:flex;align-self:start;gap:var(--size-large)}._summary_passengers_axg1q_120{border-bottom:var(--size-extra-small) solid var(--grey-200-ee);padding-bottom:var(--size-x-medium);margin-bottom:var(--size-x-medium)}._summary_price_black_axg1q_126{color:var(--neutrals-black)}._summary_subitem_icon_axg1q_130{position:relative;width:var(--s);min-width:var(--s)}._summary_subitem_content_axg1q_26{gap:var(--xs)}._summary_accordion_header_axg1q_140{gap:var(--xxs)!important;color:var(--grey-700-66)!important;width:-webkit-fit-content!important;width:-moz-fit-content!important;width:fit-content!important;align-self:end}._summary_accordion_header_axg1q_140 :hover{color:var(--primary-red-500)!important}._summary_axg1q_13>*:not(:last-child){padding-bottom:var(--xs);border-bottom:var(--size-extra-small) solid var(--grey-200-ee)}._summary_box_quotes_axg1q_156{align-items:center;border-top:var(--size-extra-small) solid var(--grey-200-ee)}._summary_wrapper_column_axg1q_161{display:flex;flex-direction:column}._summary_total_price_axg1q_166{display:flex;flex-direction:column;align-items:flex-end;text-align:right}@media screen and (max-width: 29.999rem){._summary_back_axg1q_34{padding:1rem}._summary_item_axg1q_14{font-family:var(--web-title-desktop-sm-regular-font-family);font-weight:var(--web-title-desktop-sm-regular-font-weight);line-height:var(--web-title-desktop-sm-regular-line-height);font-size:var(--web-title-desktop-sm-regular-font-size);letter-spacing:var(--web-title-desktop-sm-regular-letter-spacing);word-spacing:var(--web-title-desktop-sm-regular-paragraph-spacing);text-indent:var(--web-title-desktop-sm-regular-paragraph-indent);text-transform:var(--web-title-desktop-sm-regular-text-case);-webkit-text-decoration:var(--web-title-desktop-xs-regular-text-decoration);text-decoration:var(--web-title-desktop-xs-regular-text-decoration)}}@media screen and (min-width: 30rem){._summary_item_axg1q_14{font-family:var(--web-title-desktop-lg-regular-font-family);font-weight:var(--web-title-desktop-lg-regular-font-weight);line-height:var(--web-title-desktop-lg-regular-line-height);font-size:var(--web-title-desktop-lg-regular-font-size);letter-spacing:var(--web-title-desktop-lg-regular-letter-spacing);word-spacing:var(--web-title-desktop-lg-regular-paragraph-spacing);text-indent:var(--web-title-desktop-lg-regular-paragraph-indent);text-transform:var(--web-title-desktop-lg-regular-text-case);-webkit-text-decoration:var(--web-title-desktop-lg-regular-text-decoration);text-decoration:var(--web-title-desktop-lg-regular-text-decoration)}}._nemuru_content_9whxo_1{display:flex;align-items:center}._nemuru_icon_9whxo_6{width:var(--l);min-width:var(--l)}._nemuru_select_9whxo_11{outline:none;border:none}._nemuru_text_9whxo_16{padding-left:var(--s)}._alert_container_fqey6_1{display:flex;padding:var(--s);flex-direction:column;gap:.5rem;background-color:var(--grey-100-fa, #fafafa);border:.0625rem solid var(--grey-300-dd, #ddd);box-shadow:0 .125rem #00000012}._alert_header_fqey6_11{color:var(--primary-red-500, #d7192d);display:flex;align-items:flex-end;gap:1.375rem;font-size:var(--font-size-5);font-weight:var(--font-weights-iberia-headline-bold)}._alert_description_fqey6_20{padding-left:2.875rem;color:var(--grey-300-dd);font-weight:var(--font-weights-verdana-bold)}._alert_icon_fqey6_26{width:var(--m);color:var(--grey-300-dd)}._alert_warning_fqey6_31{background-color:var(--grey-800-33, #333);color:var(--grey-300-dd)}._alert_warning_fqey6_31 ._alert_title_fqey6_34{line-height:var(--line-height-2)}._alert_warning_fqey6_31 ._alert_description_fqey6_20{line-height:var(--line-heights-3)}._alert_error_fqey6_42{color:var(--primary-red-500, #d7192d)}._alert_info_fqey6_46{color:var(--neutrals-black, #000)}@media screen and (min-width: 48rem){._alert_container_fqey6_1{padding:var(--m) var(--s)}}._alert_container_ofyrq_1{display:flex;padding:var(--s);flex-direction:column;gap:.5rem;background-color:var(--grey-100-fa, #fafafa);border:.0625rem solid var(--grey-300-dd, #ddd);box-shadow:0 .125rem #00000012}._alert_header_ofyrq_11{color:var(--grey-700-66, #666);display:flex;align-items:flex-end;gap:.7rem}._alert_description_ofyrq_18{padding-left:2.2rem;font-weight:var(--font-weights-verdana-bold)}._alert_icon_ofyrq_23{width:var(--m)}._error_ofyrq_27{color:var(--primary-red-500, #d7192d)}._info_ofyrq_31{color:var(--grey-700-66, #666)}._info_ofyrq_31 ._alert-title_ofyrq_33{font-size:1rem;line-height:var(--line-height-2)}._info_ofyrq_31 ._alert_description_ofyrq_18{line-height:var(--line-heights-3)}@media screen and (min-width: 48rem){._alert_container_ofyrq_1{padding:var(--s) var(--l)}}._box_container_1urbe_1{display:flex;position:relative;min-width:18rem;gap:var(--s);place-content:center center;flex-direction:column;align-items:flex-start;background-color:var(--neutrals-white);border-top:var(--xxs) solid var(--primary-red-500);padding:var(--s) var(--s) var(--l)}._box_heading_1urbe_14{display:flex;width:100%;align-items:flex-end;justify-content:space-between}._box_heading_1urbe_14>._box_collapsible_1urbe_21{border:none;background-color:transparent;cursor:pointer}._box_title_1urbe_27{margin:0}._box_icon_collapsable_1urbe_31{color:var(--primary-red-500)}._box_content_1urbe_35{display:flex;flex-flow:column nowrap;width:100%;gap:var(--s)}._box_form_1urbe_42{display:flex;flex-flow:column nowrap;align-items:stretch;gap:var(--s)}._box_button_1urbe_49{width:100%;flex-shrink:0}._box_link_1urbe_54{font-family:var(--font-families-verdana);font-size:var(--font-size-2)}._box_input_icon_response_1urbe_59{display:flex;flex-flow:row nowrap;align-items:center;gap:.3125rem;font-weight:var(--font-weights-verdana-bold)}._box_input_message_box_1urbe_67{display:flex;flex-flow:column wrap;justify-content:flex-start;flex-shrink:0;flex-grow:1;padding:1.125rem 1rem;color:var(--grey-700-66, #666);border:.0625rem solid var(--color-neutrales-40, #ccc);background-color:var(--neutrals-white, #fff);font-family:var(--font-families-verdana);font-size:var(--font-size-2);line-height:1.15rem}._box_input_icon_1urbe_59{width:1rem;height:1rem;flex-shrink:0;flex-grow:0;color:var(--semantic-app-positive-action)}._box_input_text_1urbe_90{white-space:nowrap;text-overflow:ellipsis;overflow:hidden}._box_input_subtext_1urbe_96{margin-top:.5rem;margin-left:1.3125rem}._box_loading_1urbe_101{position:absolute;z-index:1;top:0;left:0;background:var(--neutrals-white)}@media screen and (min-width: 30rem){._box_container_1urbe_1{min-width:28rem}._box_form_1urbe_42{flex-flow:row nowrap;align-items:stretch}._box_input_message_box_1urbe_67{width:16rem}._box_button_1urbe_49{display:flex;width:9.5rem}}@media screen and (min-width: 48rem){._box_container_1urbe_1{min-width:initial}._box_content_1urbe_35{width:100%}._box_button_1urbe_49{display:flex;width:15rem}}@media screen and (min-width: 64rem){._box_container_1urbe_1{max-width:18rem}._box_collapsible_1urbe_21{display:none}._box_form_1urbe_42{flex-flow:column nowrap;align-items:flex-start}._box_button_1urbe_49{width:100%}._box_input_message_box_1urbe_67{width:16rem}}@media screen and (min-width: 80rem){._box_container_1urbe_1{max-width:22rem}._box_heading_1urbe_14>._box_title_1urbe_27{font-size:1.25rem}._box_input_message_box_1urbe_67{width:20rem}}")),document.head.appendChild(e)}}catch(a){console.error("vite-plugin-css-injected-by-js",a)}})();
import { jsx as o, jsxs as i, Fragment as S } from "react/jsx-runtime";
import b, { clsx as y } from "clsx";
import g, { useState as B, useEffect as q, useRef as le, useCallback as Ne, useContext as xe, createContext as Te } from "react";
import * as ne from "@radix-ui/react-collapsible";
import { I as C, T as l } from "./Icon-COuuXGxa.js";
import { I as Ce, B as ve, L as Ie } from "./Button-C7_6Cnfi.js";
import * as F from "@radix-ui/react-popover";
import * as Z from "@radix-ui/react-tabs";
import * as U from "@radix-ui/react-tooltip";
import { initReactI18next as Ee, I18nextProvider as Oe, useTranslation as h, Trans as Ae } from "react-i18next";
import { b as ce, a as _e, I as Re } from "./InputRadio-BAFYuyXe.js";
import je from "dompurify";
import * as Y from "@radix-ui/react-accordion";
import { ErrorBoundary as we } from "react-error-boundary";
import J from "i18next";
import Se from "i18next-resources-to-backend";
import { useForm as Le } from "react-hook-form";
const He = "_accordionRoot_1fwxu_1", $e = "_accordionItem_1fwxu_7", De = "_accordionHeader_1fwxu_13", qe = "_accordionTrigger_1fwxu_17", ze = "_accordionHeaderIcon_1fwxu_29", Pe = "_accordionContent_1fwxu_39", L = {
  accordionRoot: He,
  accordionItem: $e,
  accordionHeader: De,
  accordionTrigger: qe,
  accordionHeaderIcon: ze,
  accordionContent: Pe,
  "slide-down": "_slide-down_1fwxu_1",
  "slide-overflow": "_slide-overflow_1fwxu_1",
  "slide-up": "_slide-up_1fwxu_1"
}, ke = g.forwardRef(
  function({ children: e, className: n, ...r }, a) {
    const s = {
      collapsible: !0
    };
    return /* @__PURE__ */ o(Y.Root, { ref: a, ...s, ...r, className: y(L.accordionRoot, n), children: e });
  }
), Ue = g.forwardRef(
  function({ className: e, children: n, ...r }, a) {
    return /* @__PURE__ */ o(Y.Item, { ref: a, className: y(L.accordionItem, e), ...r, children: n });
  }
), me = g.forwardRef(
  function({ className: e, children: n, ...r }, a) {
    return /* @__PURE__ */ o(Y.Trigger, { ref: a, className: y(L.accordionTrigger, e), ...r, children: n });
  }
), Fe = g.forwardRef(
  function({ className: e, children: n, showTrigger: r = !0, ...a }, s) {
    return /* @__PURE__ */ o(Y.Header, { ref: s, className: y(L.accordionHeader, e), ...a, children: r ? /* @__PURE__ */ i(me, { className: y(L.accordionTrigger, e), children: [
      n,
      /* @__PURE__ */ o(C, { name: "chevron-line-down", className: L.accordionHeaderIcon })
    ] }) : n });
  }
), Be = g.forwardRef(
  function({ className: e, children: n, ...r }, a) {
    return /* @__PURE__ */ o(Y.Content, { ref: a, className: y(L.accordionContent, e), ...r, children: /* @__PURE__ */ o("div", { className: L.accordionContentContainer, children: n }) });
  }
), w = Object.assign(ke, {
  Content: Be,
  Item: Ue,
  Header: Fe,
  Trigger: me
}), m = ({ children: t, className: e, id: n }) => {
  const r = g.useId(), a = n ?? r;
  return /* @__PURE__ */ o("div", { className: y(e), "data-testid": "box-element", id: a, children: t });
}, Me = "_collapsibleContent_ij36k_1", Xe = {
  collapsibleContent: Me,
  "slide-down": "_slide-down_ij36k_1",
  "slide-overflow": "_slide-overflow_ij36k_1",
  "slide-up": "_slide-up_ij36k_1"
}, Ve = ne.Root, Ge = ne.CollapsibleTrigger, de = g.forwardRef(function({ className: e, ...n }, r) {
  return /* @__PURE__ */ o(
    ne.CollapsibleContent,
    {
      ref: r,
      className: b(Xe.collapsibleContent, e),
      ...n
    }
  );
});
de.displayName = "CollapsibleContent";
const We = "_collapsible_9uxq6_1", Ye = "_collapsibleTrigger_9uxq6_9", Qe = "_collapsibleHeading_9uxq6_24", Je = "_collapsibleHeadingHead_9uxq6_30", Ke = "_collapsibleDivider_9uxq6_36", Ze = "_collapsibleIcon_9uxq6_40", eo = "_collapsibleIconArrow_9uxq6_45", oo = "_collapsibleIconArrowOpened_9uxq6_57", no = "_collapsibleHeadingHeadTitle_9uxq6_61", to = "_collapsibleDescription_9uxq6_71", E = {
  collapsible: We,
  collapsibleTrigger: Ye,
  collapsibleHeading: Qe,
  collapsibleHeadingHead: Je,
  collapsibleDivider: Ke,
  collapsibleIcon: Ze,
  collapsibleIconArrow: eo,
  collapsibleIconArrowOpened: oo,
  collapsibleHeadingHeadTitle: no,
  collapsibleDescription: to
}, ro = ({ icon: t }) => t ? typeof t == "string" ? /* @__PURE__ */ o(C, { name: t, className: E.collapsibleIcon, role: "presentation", "aria-hidden": "true" }) : t : null;
function ir({
  iconName: t,
  title: e,
  open: n,
  onOpenChange: r,
  disabled: a = !1,
  collapsed: s = !0,
  className: _ = "",
  description: p,
  footer: x,
  children: f
}) {
  const [I, A] = B(!s), H = (O) => {
    A(O), r == null || r(O);
  };
  return q(() => {
    n !== void 0 && A(n);
  }, [n]), /* @__PURE__ */ i(
    Ve,
    {
      open: I,
      defaultOpen: !s,
      disabled: a,
      onOpenChange: H,
      className: b(E.collapsible, _),
      "data-testid": "collapsible-section",
      children: [
        /* @__PURE__ */ o(Ge, { className: E.collapsibleTrigger, children: /* @__PURE__ */ i("header", { className: E.collapsibleHeading, children: [
          /* @__PURE__ */ i("div", { className: E.collapsibleHeadingHead, children: [
            /* @__PURE__ */ o(ro, { icon: t }),
            /* @__PURE__ */ o("div", { className: E.collapsibleHeadingHeadTitle, children: /* @__PURE__ */ o(l, { as: "span", font: "iberia-headline", size: "md-regular", "data-testid": "collapsible-title", children: e }) })
          ] }),
          /* @__PURE__ */ o(
            C,
            {
              name: "chevron-line-down",
              className: b(E.collapsibleIconArrow, I && E.collapsibleIconArrowOpened),
              "data-testid": "collapsible-trigger"
            }
          )
        ] }) }),
        /* @__PURE__ */ o(Ce, { variant: "solid-light-gray", className: E.collapsibleDivider }),
        p || Array.isArray(f) && /* @__PURE__ */ o("div", { className: E.collapsibleDescription, "data-testid": "collapsible-description", children: Array.isArray(f) ? f[0] : p }),
        /* @__PURE__ */ o(de, { className: E.collapsibleContent, "data-testid": "collapsible-content", children: Array.isArray(f) ? f[1] : f }),
        /* @__PURE__ */ o("footer", { children: x })
      ]
    }
  );
}
const ao = "_content_eyhl6_1", so = {
  content: ao,
  "slide-down": "_slide-down_eyhl6_1",
  "slide-up": "_slide-up_eyhl6_1"
}, lr = F.Root, cr = F.Trigger, _r = F.Anchor, io = g.forwardRef(({ className: t, align: e = "center", sideOffset: n = 4, ...r }, a) => /* @__PURE__ */ o(F.Portal, { children: /* @__PURE__ */ o(
  F.Content,
  {
    ref: a,
    align: e,
    sideOffset: n,
    className: b(so.content, t),
    ...r
  }
) }));
io.displayName = F.Content.displayName;
const lo = "_skeleton_11f39_1", co = "_pulse_11f39_1", _o = {
  skeleton: lo,
  pulse: co
};
function mr({ className: t, ...e }) {
  return /* @__PURE__ */ o("div", { className: b(_o.skeleton, t), ...e });
}
const mo = "_visuallyHidden_7qhky_1", uo = {
  visuallyHidden: mo
}, po = g.forwardRef((t, e) => /* @__PURE__ */ o("span", { ref: e, ...t, className: b(uo.visuallyHidden, t.className) }));
po.displayName = "VisuallyHidden";
const bo = "_tabsContainer_1igt5_1", go = "_tabList_1igt5_7", ho = "_tab_1igt5_1", fo = "_tabTitle_1igt5_35", yo = "_tabText_1igt5_42", W = {
  tabsContainer: bo,
  tabList: go,
  tab: ho,
  tabTitle: fo,
  tabText: yo
}, dr = g.forwardRef(function({ className: e, defaultValue: n, children: r, ...a }, s) {
  return /* @__PURE__ */ o(
    Z.Root,
    {
      ref: s,
      className: b(W.tabsContainer, e),
      defaultValue: n,
      ...a,
      children: r
    }
  );
}), ur = g.forwardRef(function({ className: e, children: n, ...r }, a) {
  return /* @__PURE__ */ o(Z.List, { ref: a, className: b(W.tabList, e), ...r, children: n });
}), pr = g.forwardRef(function({ className: e, value: n, iconName: r, title: a, ...s }, _) {
  return /* @__PURE__ */ o(
    Z.Trigger,
    {
      ref: _,
      value: n,
      className: b(W.tab, e),
      "aria-label": n,
      ...s,
      children: /* @__PURE__ */ i("div", { className: W.tabTitle, children: [
        /* @__PURE__ */ o(C, { name: r, size: 24 }),
        /* @__PURE__ */ o(l, { as: "span", font: "iberia-headline", size: "xs-regular", className: W.tabText, children: a })
      ] })
    }
  );
}), br = Z.Content, No = "_tooltipContent_z2gl1_1", xo = "_tooltipArrow_z2gl1_10", To = "_tooltipTrigger_z2gl1_14", ee = {
  tooltipContent: No,
  tooltipArrow: xo,
  tooltipTrigger: To
}, gr = function({ children: e, ...n }) {
  return /* @__PURE__ */ o(U.Provider, { children: /* @__PURE__ */ o(U.Root, { ...n, children: e }) });
}, hr = g.forwardRef(
  function({ className: e, children: n, ...r }, a) {
    return /* @__PURE__ */ o(U.Trigger, { ref: a, className: b(ee.tooltipTrigger, e), ...r, children: n });
  }
), fr = g.forwardRef(
  function({ className: e, children: n, ...r }, a) {
    return /* @__PURE__ */ o(U.Portal, { children: /* @__PURE__ */ i(
      U.Content,
      {
        ref: a,
        role: "tooltip",
        className: b(ee.tooltipContent, e),
        side: "top",
        ...r,
        children: [
          /* @__PURE__ */ o(U.Arrow, { className: ee.tooltipArrow }),
          n
        ]
      }
    ) });
  }
), Co = "_messageBannerContainer_3mzts_1", vo = "_messageBannerHeader_3mzts_11", Io = "_messageBannerDescription_3mzts_17", Eo = "_messageBannerIcon_3mzts_21", Oo = "_error_3mzts_25", Ao = "_info_3mzts_29", X = {
  messageBannerContainer: Co,
  messageBannerHeader: vo,
  messageBannerDescription: Io,
  messageBannerIcon: Eo,
  error: Oo,
  info: Ao
};
function yr({
  title: t,
  description: e,
  className: n,
  id: r,
  type: a = "error",
  icon: s = "informacion_2",
  children: _
}) {
  const p = g.useId(), x = r ?? p;
  return /* @__PURE__ */ i(
    "section",
    {
      role: "alert",
      className: y(X.messageBannerContainer, n),
      id: `${x}-message-banner`,
      children: [
        /* @__PURE__ */ i("header", { className: X.messageBannerHeader, children: [
          /* @__PURE__ */ o(C, { name: s, className: X.messageBannerIcon }),
          /* @__PURE__ */ o(l, { className: X[a], as: "h3", font: "iberia-headline", size: "xs-regular", children: t })
        ] }),
        /* @__PURE__ */ i(l, { font: "verdana", size: "lg-regular", className: X.messageBannerDescription, children: [
          e,
          _
        ] })
      ]
    }
  );
}
const Ro = "_outerContainer_f2f7y_3", jo = "_innerContainer_f2f7y_11", wo = "_innerContainerVertical_f2f7y_20", So = "_spinnerWrapper_f2f7y_24", Lo = "_innerContainerSmall_f2f7y_30", Ho = "_innerContainerMedium_f2f7y_35", $o = "_spinnerContainer_f2f7y_40", Do = "_spinnerCircle_f2f7y_60", qo = "_spinnerFirstCircle_f2f7y_74", zo = "_spinnerDark_f2f7y_78", Po = "_spinnerSecondCircle_f2f7y_82", ko = "_spinnerText_f2f7y_87", v = {
  outerContainer: Ro,
  innerContainer: jo,
  innerContainerVertical: wo,
  spinnerWrapper: So,
  innerContainerSmall: Lo,
  innerContainerMedium: Ho,
  spinnerContainer: $o,
  spinnerCircle: Do,
  "spinner-animation": "_spinner-animation_f2f7y_1",
  spinnerFirstCircle: qo,
  spinnerDark: zo,
  spinnerSecondCircle: Po,
  spinnerText: ko
};
function ue({
  children: t,
  orientation: e,
  variant: n = "light",
  size: r = "big",
  className: a
}) {
  return /* @__PURE__ */ o("div", { className: y(v.outerContainer, a), children: /* @__PURE__ */ i(
    "div",
    {
      className: y(v.innerContainer, {
        [v.innerContainerVertical]: e === "vertical",
        [v.innerContainerSmall]: r === "small",
        [v.innerContainerMedium]: r === "medium"
      }),
      children: [
        /* @__PURE__ */ o("div", { className: v.spinnerWrapper, children: /* @__PURE__ */ i("div", { className: v.spinnerContainer, children: [
          /* @__PURE__ */ o(
            "div",
            {
              className: y(v.spinnerCircle, v.spinnerFirstCircle, {
                [v.spinnerDark]: n === "dark"
              })
            }
          ),
          /* @__PURE__ */ o("div", { className: y(v.spinnerCircle, v.spinnerSecondCircle) })
        ] }) }),
        t && /* @__PURE__ */ o("span", { className: v.spinnerText, children: t })
      ]
    }
  ) });
}
const Uo = "_overlay_f9e72_1", Fo = "_content_f9e72_15", Bo = "_title_f9e72_19", Mo = "_divider_f9e72_25", Xo = "_subtitle_f9e72_33", V = {
  overlay: Uo,
  content: Fo,
  title: Bo,
  divider: Mo,
  subtitle: Xo
};
function Vo({ intervalTime: t = 0, callback: e }) {
  const n = le(), r = Ne(e, [e]), a = () => {
    n.current = window.setInterval(r, t);
  }, s = () => {
    clearInterval(n.current), n.current = void 0;
  }, _ = () => {
    s(), a();
  };
  return q(() => () => {
    s();
  }, [t]), { start: a, reset: _, stop: s };
}
function Nr({ title: t, subtitles: e = [], textTransition: n, isOpen: r }) {
  const [a, s] = B(0), { stop: _, reset: p } = Vo({
    callback: () => {
      s((x) => x + 1);
    },
    intervalTime: n
  });
  return q(() => {
    r ? (s(0), e.length > 0 && p()) : _();
  }, [r, e]), q(() => {
    a >= e.length - 1 && _();
  }, [a]), r ? /* @__PURE__ */ o("div", { className: V.overlay, children: /* @__PURE__ */ o("div", { className: V.content, children: /* @__PURE__ */ i(ue, { size: "big", children: [
    t && /* @__PURE__ */ o(l, { as: "h1", font: "iberia-headline", size: "xl-regular", className: V.title, children: t }),
    e.length > 0 && /* @__PURE__ */ i(S, { children: [
      /* @__PURE__ */ o("hr", { className: V.divider }),
      /* @__PURE__ */ o(l, { as: "p", font: "iberia-headline", size: "md-bold", className: V.subtitle, children: e[a] })
    ] })
  ] }) }) }) : null;
}
const Go = (t, e, n) => {
  const r = t[e];
  return r ? typeof r == "function" ? r() : Promise.resolve(r) : new Promise((a, s) => {
    (typeof queueMicrotask == "function" ? queueMicrotask : setTimeout)(
      s.bind(
        null,
        new Error(
          "Unknown variable dynamic import: " + e + (e.split("/").length !== n ? ". Note that variables only represent file names one level deep." : "")
        )
      )
    );
  });
}, re = "common";
J.use(Ee).use(
  Se(async (t, e) => Go(/* @__PURE__ */ Object.assign({ "./locales/ca/alert-upgrading-avios.json": () => import("./alert-upgrading-avios-7it761Bg.js"), "./locales/ca/alert-upgrading-bids.json": () => import("./alert-upgrading-bids-q5hB85le.js"), "./locales/ca/common.json": () => import("./common-C9v25mT7.js"), "./locales/ca/nemuru.json": () => import("./nemuru-DuP8Ew3W.js"), "./locales/ca/onhold-free.json": () => import("./onhold-free-CbIrg8Lm.js"), "./locales/ca/onhold-options.json": () => import("./onhold-options-BXH3P202.js"), "./locales/ca/summary.json": () => import("./summary-DFc5CSEz.js"), "./locales/ca/voucher.json": () => import("./voucher-B8keO2Pj.js"), "./locales/de/alert-upgrading-avios.json": () => import("./alert-upgrading-avios-ZCq_zNOE.js"), "./locales/de/alert-upgrading-bids.json": () => import("./alert-upgrading-bids-BenFM6EK.js"), "./locales/de/common.json": () => import("./common-zkFPTdPj.js"), "./locales/de/nemuru.json": () => import("./nemuru-DbafGfRV.js"), "./locales/de/onhold-free.json": () => import("./onhold-free-C0cz9A6B.js"), "./locales/de/onhold-options.json": () => import("./onhold-options-q_xR3MfC.js"), "./locales/de/summary.json": () => import("./summary-DKLN3HDx.js"), "./locales/de/voucher.json": () => import("./voucher-DM7lnE8M.js"), "./locales/en/alert-upgrading-avios.json": () => import("./alert-upgrading-avios-B9YWy3aA.js"), "./locales/en/alert-upgrading-bids.json": () => import("./alert-upgrading-bids-DrW37J_I.js"), "./locales/en/common.json": () => import("./common-CnbYNMeV.js"), "./locales/en/nemuru.json": () => import("./nemuru-hM1Z8T2C.js"), "./locales/en/onhold-free.json": () => import("./onhold-free-DoxAPX68.js"), "./locales/en/onhold-options.json": () => import("./onhold-options-B6AywnzC.js"), "./locales/en/summary.json": () => import("./summary-DQulGGhh.js"), "./locales/en/voucher.json": () => import("./voucher-BbdLp3cL.js"), "./locales/es/alert-upgrading-avios.json": () => import("./alert-upgrading-avios-QpquZXSG.js"), "./locales/es/alert-upgrading-bids.json": () => import("./alert-upgrading-bids-Bcoe6L8S.js"), "./locales/es/common.json": () => import("./common-BDVF1TQr.js"), "./locales/es/nemuru.json": () => import("./nemuru-C84Z5Iq4.js"), "./locales/es/onhold-free.json": () => import("./onhold-free-BRZEBPfT.js"), "./locales/es/onhold-options.json": () => import("./onhold-options-CFeVg17E.js"), "./locales/es/summary.json": () => import("./summary-phlkQU-6.js"), "./locales/es/voucher.json": () => import("./voucher-CuWXuz_j.js"), "./locales/fr/alert-upgrading-avios.json": () => import("./alert-upgrading-avios-BPpTIMlr.js"), "./locales/fr/alert-upgrading-bids.json": () => import("./alert-upgrading-bids-aUPik36Y.js"), "./locales/fr/common.json": () => import("./common-CLFuIRFM.js"), "./locales/fr/nemuru.json": () => import("./nemuru-CiL_9Hdi.js"), "./locales/fr/onhold-free.json": () => import("./onhold-free-BrBvPWqT.js"), "./locales/fr/onhold-free2.json": () => import("./onhold-free2-CoJXs60G.js"), "./locales/fr/onhold-options.json": () => import("./onhold-options-DA3ATzqy.js"), "./locales/fr/summary.json": () => import("./summary-ctsCKtci.js"), "./locales/fr/voucher.json": () => import("./voucher-BGknsLms.js"), "./locales/it/alert-upgrading-avios.json": () => import("./alert-upgrading-avios-WaUPFjGI.js"), "./locales/it/alert-upgrading-bids.json": () => import("./alert-upgrading-bids-Cs6M9CFk.js"), "./locales/it/common.json": () => import("./common-DWUalKa_.js"), "./locales/it/nemuru.json": () => import("./nemuru-DCiSrSLO.js"), "./locales/it/onhold-free.json": () => import("./onhold-free-CdCfynsh.js"), "./locales/it/onhold-options.json": () => import("./onhold-options-B2FpcLjK.js"), "./locales/it/summary.json": () => import("./summary-orRtosE4.js"), "./locales/it/voucher.json": () => import("./voucher-CIJROHuA.js"), "./locales/ja/alert-upgrading-avios.json": () => import("./alert-upgrading-avios-DIsi-cA5.js"), "./locales/ja/alert-upgrading-bids.json": () => import("./alert-upgrading-bids-BMsCWDXP.js"), "./locales/ja/common.json": () => import("./common-52Qe3zVV.js"), "./locales/ja/nemuru.json": () => import("./nemuru-DyAwUrZa.js"), "./locales/ja/onhold-free.json": () => import("./onhold-free-D6Rio12Z.js"), "./locales/ja/onhold-options.json": () => import("./onhold-options-0TMZsW8v.js"), "./locales/ja/summary.json": () => import("./summary-COCxBifq.js"), "./locales/ja/voucher.json": () => import("./voucher-CtoEQVDw.js"), "./locales/nl/alert-upgrading-avios.json": () => import("./alert-upgrading-avios-BdAheqcX.js"), "./locales/nl/alert-upgrading-bids.json": () => import("./alert-upgrading-bids-BdAheqcX.js"), "./locales/nl/common.json": () => import("./common-CkMY4m7-.js"), "./locales/nl/nemuru.json": () => import("./nemuru-CstMuh1T.js"), "./locales/nl/onhold-free.json": () => import("./onhold-free-tNHuStCb.js"), "./locales/nl/onhold-options.json": () => import("./onhold-options-CwcN3fji.js"), "./locales/nl/summary.json": () => import("./summary-B7yJnn65.js"), "./locales/nl/voucher.json": () => import("./voucher-C3fLUtjP.js"), "./locales/pt/alert-upgrading-avios.json": () => import("./alert-upgrading-avios-Xd_P9cOp.js"), "./locales/pt/alert-upgrading-bids.json": () => import("./alert-upgrading-bids-BtB16hIX.js"), "./locales/pt/common.json": () => import("./common-KIrftSO9.js"), "./locales/pt/nemuru.json": () => import("./nemuru-DBsYWHmD.js"), "./locales/pt/onhold-free.json": () => import("./onhold-free-BZAvy0os.js"), "./locales/pt/onhold-options.json": () => import("./onhold-options-BVEnokzv.js"), "./locales/pt/summary.json": () => import("./summary-Cxpfgs8A.js"), "./locales/pt/voucher.json": () => import("./voucher-C1275h1D.js"), "./locales/ru/alert-upgrading-avios.json": () => import("./alert-upgrading-avios-C4_mj_6Z.js"), "./locales/ru/alert-upgrading-bids.json": () => import("./alert-upgrading-bids-Cd6ByOFo.js"), "./locales/ru/common.json": () => import("./common-D_9GJ4cN.js"), "./locales/ru/nemuru.json": () => import("./nemuru-DhbTxMol.js"), "./locales/ru/onhold-free.json": () => import("./onhold-free-TFdsHVxk.js"), "./locales/ru/onhold-options.json": () => import("./onhold-options-BiFSwIV8.js"), "./locales/ru/summary.json": () => import("./summary-BmK9r7Cz.js"), "./locales/ru/voucher.json": () => import("./voucher-FD2bOmSI.js"), "./locales/zh/alert-upgrading-avios.json": () => import("./alert-upgrading-avios-5LZ8dedw.js"), "./locales/zh/alert-upgrading-bids.json": () => import("./alert-upgrading-bids-B_C2SE2Y.js"), "./locales/zh/common.json": () => import("./common-u5Qwtuzb.js"), "./locales/zh/nemuru.json": () => import("./nemuru-BcEO34fu.js"), "./locales/zh/onhold-free.json": () => import("./onhold-free-7Cr6-Yxk.js"), "./locales/zh/onhold-options.json": () => import("./onhold-options-B9tTtkf3.js"), "./locales/zh/summary.json": () => import("./summary-CHMbPIgt.js"), "./locales/zh/voucher.json": () => import("./voucher-CAznJq94.js") }), `./locales/${t}/${e}.json`, 4))
).init({
  debug: !1,
  fallbackLng: "es",
  ns: [re],
  defaultNS: re
});
const M = (t) => {
  const e = (n) => {
    const a = new URLSearchParams(window.location.search).get("language");
    return a && J.language !== a && J.changeLanguage(a).catch((s) => {
      console.error("Error changing language:", s);
    }), /* @__PURE__ */ o(we, { fallback: /* @__PURE__ */ o(S, { children: "Error" }), children: /* @__PURE__ */ o(Oe, { i18n: J, children: /* @__PURE__ */ o(t, { ...n }) }) });
  };
  return e.displayName = `WithProviders(${t.displayName || t.name || "Component"})`, e;
}, Wo = "_option_header_12ple_8", Yo = "_option_header_subtext_12ple_16", Qo = "_option_header_collapsed_12ple_21", Jo = "_option_header_text_collapsed_12ple_25", Ko = "_option_header_subtext_collapsed_12ple_32", Zo = "_option_body_12ple_36", en = "_option_body_content_12ple_43", on = "_option_body_text_12ple_48", nn = "_option_footer_12ple_54", tn = "_option_footer_collapsed_12ple_58", rn = "_option_wrapper_12ple_62", an = "_option_not_selected_12ple_70", sn = "_option_icon_container_12ple_74", ln = "_option_icon_12ple_74", cn = "_option_label_12ple_84", _n = "_option_label_text_12ple_90", mn = "_option_radio_button_12ple_94", dn = "_option_wrapper_collapsed_12ple_106", un = "_option_collapsed_bg_12ple_112", pn = "_option_label_collapsed_12ple_117", bn = "_option_radio_button_collapsed_12ple_126", gn = "_option_accordion_item_12ple_133", u = {
  option_header: Wo,
  option_header_subtext: Yo,
  option_header_collapsed: Qo,
  option_header_text_collapsed: Jo,
  option_header_subtext_collapsed: Ko,
  option_body: Zo,
  option_body_content: en,
  option_body_text: on,
  option_footer: nn,
  option_footer_collapsed: tn,
  option_wrapper: rn,
  option_not_selected: an,
  option_icon_container: sn,
  option_icon: ln,
  option_label: cn,
  option_label_text: _n,
  option_radio_button: mn,
  option_wrapper_collapsed: dn,
  option_collapsed_bg: un,
  option_label_collapsed: pn,
  option_radio_button_collapsed: bn,
  option_accordion_item: gn
}, pe = ({ option: t }) => {
  const { t: e } = h(["onhold-options", "common"]), n = [
    {
      iconName: "reloj-bold",
      text: `${e("INSTRUCTION_START")} ${String(t.hours)} ${e("DURATION_HOURS")}, ${String(
        t.transformedTimeDateLimit.day
      )} ${e("common:MONTH_FEBRUARY")} ${e("INSTRUCTION_UNTIL_MONTH")} ${String(t.transformedTimeDateLimit.year)} ${e(
        "INSTRUCTION_UNTIL_TIME"
      )} ${t.transformedTimeDateLimit.hour}:${t.transformedTimeDateLimit.minutes} (${t.cityDescription})`
    },
    { iconName: "calendario-reembolso", text: e("PRICE_LOCK_EXPLANATION") },
    { iconName: "mejor-precio", text: t.total === 0 ? e("FREE_RESERVATION") : e("DEPOSIT_DISCOUNT_EXPLANATION") },
    { iconName: "atencion-telefonica", text: e("EXPIRATION_WARNING") }
  ];
  return /* @__PURE__ */ o(m, { className: u.option_body, children: n.map((r, a) => /* @__PURE__ */ i(m, { className: u.option_body_content, children: [
    /* @__PURE__ */ o(m, { className: u.option_icon_container, children: /* @__PURE__ */ o(C, { className: u.option_icon, name: r.iconName }) }),
    /* @__PURE__ */ o(l, { className: u.option_body_text, as: "span", font: "verdana", size: "lg-regular", children: r.text })
  ] }, a)) });
}, be = ({ option: t, collapsed: e }) => {
  const { t: n } = h("onhold-options");
  return /* @__PURE__ */ i(m, { className: e ? u.option_header_text_collapsed : u.option_header, children: [
    /* @__PURE__ */ o(l, { as: "span", font: "verdana", size: e ? "lg-bold" : "cabin-price", children: t.hours }),
    /* @__PURE__ */ o(
      l,
      {
        className: e ? u.option_header_subtext_collapsed : u.option_header_subtext,
        as: "span",
        font: "verdana",
        size: "lg-regular",
        children: n("DURATION_UNIT")
      }
    )
  ] });
}, ge = ({ option: t, collapsed: e }) => {
  const { t: n } = h("onhold-options");
  return /* @__PURE__ */ i(m, { className: e ? u.option_label_collapsed : u.option_label, children: [
    /* @__PURE__ */ o(l, { as: "span", font: "verdana", size: e ? "lg-regular" : "cabin-name", children: t.total === 0 ? n("FREE") : t.totalFormatted }),
    /* @__PURE__ */ o(l, { className: u.option_label_text, as: "span", font: "verdana", size: "lg-regular", children: t.total !== 0 ? n("PER_PASSENGER_NOTICE") : "" })
  ] });
}, hn = ({
  data: t,
  onChange: e,
  value: n
}) => /* @__PURE__ */ o(ce, { direction: "vertical", ariaLabel: "onhold-options", children: t.map((r) => /* @__PURE__ */ o(
  m,
  {
    className: b(u.option_wrapper_collapsed, u.option_header_collapsed, {
      [u.option_not_selected]: r.onHoldOptionId !== n
    }),
    children: /* @__PURE__ */ o(w, { type: "single", children: /* @__PURE__ */ i(w.Item, { className: u.option_accordion_item, value: "1", children: [
      /* @__PURE__ */ i(w.Header, { className: u.option_collapsed_bg, children: [
        /* @__PURE__ */ o(
          _e,
          {
            onChange: (a) => {
              a.stopPropagation(), e(r.onHoldOptionId);
            },
            onClick: (a) => {
              a.stopPropagation();
            },
            defaultChecked: n === r.onHoldOptionId,
            className: u.option_radio_button_collapsed,
            value: r.onHoldOptionId,
            "data-testid": r.onHoldOptionId,
            label: /* @__PURE__ */ o(be, { option: r, collapsed: !0 }),
            name: "option-onhold"
          }
        ),
        /* @__PURE__ */ o(l, { as: "span", font: "verdana", size: "md-regular", children: /* @__PURE__ */ o(ge, { collapsed: !0, "data-testid": `price-${r.onHoldOptionId}`, option: r }) })
      ] }),
      /* @__PURE__ */ o(w.Content, { children: /* @__PURE__ */ o(pe, { option: r }) })
    ] }) })
  },
  r.onHoldOptionId
)) }), fn = ({
  data: t,
  onChange: e,
  value: n
}) => /* @__PURE__ */ o(ce, { className: u.radioGroup, ariaLabel: "onhold-options", children: t.map((r) => /* @__PURE__ */ i(
  m,
  {
    className: b(u.option_wrapper, { [u.option_not_selected]: r.onHoldOptionId !== n }),
    children: [
      /* @__PURE__ */ o("header", { children: /* @__PURE__ */ o(be, { option: r }) }),
      /* @__PURE__ */ o(pe, { option: r }),
      /* @__PURE__ */ o(m, { className: u.option_footer, children: /* @__PURE__ */ o(
        _e,
        {
          onChange: () => {
            e(r.onHoldOptionId);
          },
          "data-testid": r.onHoldOptionId,
          defaultChecked: n === r.onHoldOptionId,
          className: u.option_radio_button,
          value: r.onHoldOptionId,
          label: /* @__PURE__ */ o(ge, { option: r }),
          name: "option-onhold"
        }
      ) })
    ]
  },
  r.onHoldOptionId
)) }), te = ({
  threshold: t = 1024,
  overThresholdCollapsed: e,
  underThresholdCollapsed: n
}) => {
  const r = () => window.innerWidth >= t ? e : n, [a, s] = B(r()), _ = le(window.innerWidth);
  return q(() => {
    const p = (x, f) => {
      const I = r(), A = _.current < t && window.innerWidth >= t, H = _.current >= t && window.innerWidth < t;
      (f || A || H) && s(I), _.current = window.innerWidth;
    };
    return window.addEventListener("resize", p), p(null, !0), () => {
      window.removeEventListener("resize", p);
    };
  }, [t, e, n]), [a, s];
}, ae = {
  hour: "9",
  minutes: "28",
  day: 23,
  month: "February",
  year: 2024
}, yn = [
  {
    onHoldOptionId: "fake-id-0",
    hours: 24,
    cityDescription: "Miami",
    total: 0,
    totalFormatted: "0",
    transformedTimeDateLimit: ae
  },
  {
    onHoldOptionId: "fake-id-1",
    hours: 72,
    cityDescription: "Miami",
    total: 5,
    totalFormatted: "5",
    transformedTimeDateLimit: ae
  }
], Nn = ({ onChange: t, value: e, options: n = yn, collapsed: r }) => {
  const [a] = te({
    threshold: 768,
    underThresholdCollapsed: r ?? !0,
    overThresholdCollapsed: r ?? !1
  });
  return a ? /* @__PURE__ */ o(hn, { data: n, onChange: t, value: e }) : /* @__PURE__ */ o(fn, { data: n, onChange: t, value: e });
}, xr = M(Nn), xn = "_card_wrapper_1g9l3_1", Tn = "_card_icon_1g9l3_12", Cn = "_card_title_1g9l3_18", G = {
  card_wrapper: xn,
  card_icon: Tn,
  card_title: Cn
}, vn = (t) => t === "time" ? "reloj-bold" : t === "price" ? "calendario-reembolso" : "mejor-precio", In = (t) => {
  const { t: e } = h(["onhold-free", "common"]), { type: n } = t;
  return /* @__PURE__ */ i(m, { className: G.card_wrapper, children: [
    /* @__PURE__ */ o(C, { className: G.card_icon, name: vn(n) }),
    n === "discount" && /* @__PURE__ */ i(S, { children: [
      /* @__PURE__ */ o(l, { as: "span", font: "verdana", size: "md-regular", className: G.card_title, children: (t.total === 0, e("ON_HOLD_ONE_OPTION_TITLE")) }),
      /* @__PURE__ */ i("span", { children: [
        /* @__PURE__ */ o(l, { as: "span", font: "verdana", size: "md-bold", children: `${t.total === 0 ? e("ONHOLD_FREE_TEXT_1_1") : e("ON_HOLD_ONE_OPTION_TEXT_1_1")} ` }),
        /* @__PURE__ */ o(l, { as: "span", font: "verdana", size: "md-regular", children: t.total === 0 ? "" : e("ON_HOLD_ONE_OPTION_TEXT_1_2") })
      ] })
    ] }),
    n === "time" && /* @__PURE__ */ i(S, { children: [
      /* @__PURE__ */ o(l, { as: "span", font: "verdana", size: "md-regular", className: G.card_title, children: `${t.hours} ${e("ONHOLD_FREE_TITLE_2")}` }),
      /* @__PURE__ */ i("span", { children: [
        /* @__PURE__ */ o(l, { as: "span", font: "verdana", size: "md-regular", children: `${e("ONHOLD_FREE_TEXT_2_1")} ` }),
        /* @__PURE__ */ o(l, { as: "span", font: "verdana", size: "md-bold", children: `${t.hours} ${e("ONHOLD_FREE_TEXT_2_2")} ` }),
        /* @__PURE__ */ o(l, { as: "span", font: "verdana", size: "md-regular", children: `${e("ONHOLD_FREE_TEXT_2_3")} ` }),
        /* @__PURE__ */ o(l, { as: "span", font: "verdana", size: "md-bold", children: `${t.day} ${e("ONHOLD_FREE_TEXT_2_4")} ${t.month} ${e("ONHOLD_FREE_TEXT_2_4")} ${t.year} ${e("ONHOLD_FREE_TEXT_2_5")} ${t.hour}:${t.minutes} (${t.description})` })
      ] })
    ] }),
    n === "price" && /* @__PURE__ */ i(S, { children: [
      /* @__PURE__ */ o(l, { as: "span", font: "verdana", size: "md-regular", className: G.card_title, children: e("ONHOLD_FREE_TITLE_3") }),
      /* @__PURE__ */ i("span", { children: [
        /* @__PURE__ */ i(l, { as: "span", font: "verdana", size: "md-bold", children: [
          e("ONHOLD_FREE_TEXT_3_1"),
          " "
        ] }),
        /* @__PURE__ */ i(l, { as: "span", font: "verdana", size: "md-regular", children: [
          e("ONHOLD_FREE_TEXT_3_2"),
          " ",
          e("ONHOLD_FREE_TEXT_3_3")
        ] })
      ] })
    ] })
  ] });
}, Tr = M(In), En = "_summary_axg1q_13", On = "_summary_item_axg1q_14", An = "_summary_item_children_axg1q_15", Rn = "_summary_collapsed_axg1q_20", jn = "_summary_item_content_axg1q_25", wn = "_summary_subitem_content_axg1q_26", Sn = "_summary_back_axg1q_34", Ln = "_summary_subitem_click_axg1q_41", Hn = "_summary_item_body_axg1q_47", $n = "_summary_item_box_total_axg1q_55", Dn = "_summary_total_axg1q_63", qn = "_summary_icon_axg1q_67", zn = "_summary_icon_go_axg1q_72", Pn = "_summary_icon_return_axg1q_76", kn = "_summary_price_axg1q_80", Un = "_summary_subtitle_axg1q_85", Fn = "_summary_display_row_axg1q_89", Bn = "_summary_price_align_axg1q_94", Mn = "_summary_text_fit_axg1q_98", Xn = "_summary_item_title_axg1q_102", Vn = "_summary_item_icon_children_axg1q_106", Gn = "_summary_subitem_title_axg1q_114", Wn = "_summary_passengers_axg1q_120", Yn = "_summary_price_black_axg1q_126", Qn = "_summary_subitem_icon_axg1q_130", Jn = "_summary_accordion_header_axg1q_140", Kn = "_summary_box_quotes_axg1q_156", Zn = "_summary_wrapper_column_axg1q_161", et = "_summary_total_price_axg1q_166", c = {
  summary: En,
  summary_item: On,
  summary_item_children: An,
  summary_collapsed: Rn,
  summary_item_content: jn,
  summary_subitem_content: wn,
  summary_back: Sn,
  summary_subitem_click: Ln,
  summary_item_body: Hn,
  summary_item_box_total: $n,
  summary_total: Dn,
  summary_icon: qn,
  summary_icon_go: zn,
  summary_icon_return: Pn,
  summary_price: kn,
  summary_subtitle: Un,
  summary_display_row: Fn,
  summary_price_align: Bn,
  summary_text_fit: Mn,
  summary_item_title: Xn,
  summary_item_icon_children: Vn,
  summary_subitem_title: Gn,
  summary_passengers: Wn,
  summary_price_black: Yn,
  summary_subitem_icon: Qn,
  summary_accordion_header: Jn,
  summary_box_quotes: Kn,
  summary_wrapper_column: Zn,
  summary_total_price: et
}, z = (t) => {
  const { icon: e, title: n, titleColor: r, children: a, total: s } = t;
  return /* @__PURE__ */ i(m, { className: c.summary_item, children: [
    n && /* @__PURE__ */ i(m, { className: c.summary_display_row, children: [
      e && /* @__PURE__ */ o(
        C,
        {
          className: b(c.summary_icon, {
            [c.summary_icon_go]: e === "go",
            [c.summary_icon_return]: e === "return"
          }),
          name: "vuelos"
        }
      ),
      !a && /* @__PURE__ */ o(l, { className: e && c.summary_item_title, style: { color: r }, font: "iberia-headline", children: n }),
      a && /* @__PURE__ */ o(
        l,
        {
          className: e && c.summary_item_title,
          style: { color: r },
          font: "iberia-headline",
          size: "md-regular",
          children: n
        }
      )
    ] }),
    a,
    s && /* @__PURE__ */ i(m, { className: c.summary_item_box_total, children: [
      /* @__PURE__ */ o(l, { className: c.summary_text_fit, font: "verdana", size: "lg-bold", children: s.title }),
      /* @__PURE__ */ o(l, { className: c.summary_price_align, font: "verdana", size: "lg-bold", children: s.price })
    ] })
  ] });
}, j = (t) => {
  const { icon: e, number: n, text: r, price: a, children: s } = t;
  return /* @__PURE__ */ i(
    m,
    {
      className: b((e || n || r) && s ? c.summary_subitem_content : c.summary_subtitle),
      children: [
        /* @__PURE__ */ i(m, { className: c.summary_price, children: [
          /* @__PURE__ */ i(m, { className: c.summary_subitem_title, children: [
            e && /* @__PURE__ */ o(C, { className: c.summary_subitem_icon, name: e }),
            (r || n) && /* @__PURE__ */ o(l, { className: e && c.summary_subitem_title, as: "span", font: "verdana", size: "lg-bold", children: n ? `${String(n)} ${String(r)}` : r })
          ] }),
          a && /* @__PURE__ */ o(l, { className: c.summary_price_black, font: "verdana", size: "lg-regular", children: a })
        ] }),
        /* @__PURE__ */ o(m, { className: e ? c.summary_item_icon_children : c.summary_item_children, children: s })
      ]
    }
  );
}, T = (t) => {
  const { amountEnd: e, amount: n, text: r, price: a, onClick: s } = t, _ = je.sanitize("<p>" + r + "</p>");
  return /* @__PURE__ */ i(m, { className: c.summary_item_body, children: [
    /* @__PURE__ */ o(
      l,
      {
        className: c.summary_item_content,
        font: "verdana",
        size: "lg-regular",
        dangerouslySetInnerHTML: { __html: !e && n ? `${String(n)} ${r}` : _ }
      }
    ),
    /* @__PURE__ */ o(
      l,
      {
        className: b({
          [c.summary_price_black]: e,
          [c.summary_subitem_click]: s
        }),
        font: "verdana",
        size: "lg-regular",
        onClick: s && s,
        children: e && n ? `${String(n)} x ${String(a)}` : a
      }
    )
  ] });
}, ot = (t) => {
  const { t: e } = h("summary"), { ancillarie: n } = t;
  return /* @__PURE__ */ o(
    z,
    {
      title: e(`ANCILLARIES_${n.code}`),
      total: {
        title: e(`ANCILLARIES_TOTAL_${n.code}`),
        price: n.total
      },
      children: n.segments ? n.segments.map((r) => /* @__PURE__ */ o(j, { text: r.title, children: /* @__PURE__ */ o(m, { className: c.item__children, children: r.items.map((a) => /* @__PURE__ */ o(
        T,
        {
          text: a.description,
          price: a.price,
          amount: a.amount
        },
        a.code
      )) }) }, r.id)) : n.type && /* @__PURE__ */ o(m, { className: c.item__children, children: /* @__PURE__ */ o(T, { text: n.type, price: n.total }) })
    }
  );
}, se = (t) => {
  const [e, n] = B(!0), { textHide: r, textShow: a } = t;
  return /* @__PURE__ */ o(
    w.Header,
    {
      className: c.summary_accordion_header,
      onClick: () => {
        n((s) => !s);
      },
      children: /* @__PURE__ */ o(l, { className: c.summary_accordion_title, as: "span", font: "verdana", size: "md-regular", children: e ? a : r })
    }
  );
}, oe = (t) => {
  const { triggerPosition: e = "bottom", textShow: n, textHide: r, children: a } = t;
  return /* @__PURE__ */ o(w, { type: "single", children: /* @__PURE__ */ i(w.Item, { value: "summary-accordion", children: [
    e === "top" && /* @__PURE__ */ o(se, { textShow: n, textHide: r }),
    /* @__PURE__ */ o(w.Content, { children: /* @__PURE__ */ o(m, { className: c.summary_item, children: a }) }),
    e === "bottom" && /* @__PURE__ */ o(se, { textShow: n, textHide: r })
  ] }) });
}, nt = (t) => {
  const { title: e, price: n, subtitle: r, dccPrice: a, avios: s } = t;
  return /* @__PURE__ */ i(m, { className: c.summary_price, children: [
    /* @__PURE__ */ i(m, { children: [
      /* @__PURE__ */ o(l, { font: "iberia-headline", size: "sm-regular", children: e }),
      r && /* @__PURE__ */ o(m, { className: c.summary_price, children: /* @__PURE__ */ o(l, { font: "verdana", size: "md-regular", children: r }) })
    ] }),
    /* @__PURE__ */ i(m, { className: c.summary_total_price, children: [
      /* @__PURE__ */ o(l, { font: "iberia-headline", size: "sm-regular", children: s ? `${s} Avios + ${n}` : n }),
      /* @__PURE__ */ o(l, { className: c.summary_subtitle, font: "verdana", size: "sm-regular", children: a })
    ] })
  ] });
}, tt = (t) => {
  const { t: e } = h("summary"), { passenger: n } = t, r = n.names.length > 1 ? `SOME_${n.type}` : n.type;
  return /* @__PURE__ */ i(
    j,
    {
      icon: n.type === "ADULT" ? "pasajero-masculino" : n.type === "CHILD" ? "ninos" : "bebes",
      text: e(r),
      number: n.names.length,
      children: [
        /* @__PURE__ */ o(m, { className: c.summary_passengers, children: n.names.map((a, s) => /* @__PURE__ */ o(T, { text: a }, `passenger_${String(s)}`)) }),
        n.avios && /* @__PURE__ */ o(
          T,
          {
            text: e("AVIOS"),
            price: `${n.avios} ${String(e("AVIOS"))}`,
            amount: n.names.length,
            amountEnd: !0
          }
        ),
        /* @__PURE__ */ o(
          T,
          {
            text: e("FARE"),
            price: n.fare,
            amount: n.names.length,
            amountEnd: !0
          }
        ),
        /* @__PURE__ */ o(
          T,
          {
            text: e("OPERATOR_FEES"),
            price: n.taxes,
            onClick: () => {
              t.onClick(n.type);
            }
          }
        )
      ]
    }
  );
}, rt = {
  CABINA: "maleta-15kg",
  EQMANO: "maleta-15kg",
  EQBODEGA: "equipaje-10-14kg",
  ASIENTO: "asiento",
  ASIENTOPREFERENTE: "asiento-upgrade",
  ASIENTOXL: "asiento-plus",
  ASIENTODELANTERO: "asiento-delantero",
  CAMBIO: "calendario",
  REEMBOLSO: "calendario-reembolso",
  CHECKINDESK: "validar",
  SALAVIP: "sala-vip",
  FASTTRACK: "fast-track",
  TARJEMBANTIC: "passbook-tarjeta-embarque",
  EQPPRIOR: "embarque-prioritario",
  COMIDA: "bandeja-comida",
  EMBARQUE: "embarque-prioritario",
  AVIO: "avios-filled",
  WIFI: "alerta"
}, at = (t) => rt[t], he = (t) => {
  const { t: e } = h("summary"), { trip: n, indexTrip: r, stopover: a = !1, collapsed: s = !1 } = t;
  return /* @__PURE__ */ i(S, { children: [
    /* @__PURE__ */ i(
      z,
      {
        title: a ? `${String(e("JOURNEY"))} ${String(r + 1)}` : e(r === 0 ? "OUTBOUND_JOURNEY" : "RETURN_JOURNEY"),
        titleColor: a ? void 0 : "#d7192d",
        icon: a ? void 0 : r === 0 ? "go" : "return",
        children: [
          /* @__PURE__ */ o(
            ie,
            {
              fragment: n.departure,
              route: n.routeFormatted,
              routeCode: n.routeCodeFormatted,
              collapsed: s
            }
          ),
          !s && /* @__PURE__ */ i(oe, { textShow: e("FLIGHT_DETAILS_CLOSED"), textHide: e("FLIGHT_DETAILS_OPENED"), children: [
            /* @__PURE__ */ o(
              ie,
              {
                fragment: n.arrival,
                destinationCity: n.arrival.city,
                collapsed: s
              }
            ),
            /* @__PURE__ */ i(j, { text: n.flight.title, children: [
              /* @__PURE__ */ o(T, { text: n.flight.operatedBy }),
              /* @__PURE__ */ o(T, { text: n.flight.airplane })
            ] }),
            /* @__PURE__ */ o(j, { text: `${String(e("DURATION"))}  ${n.duration}` }),
            n.waitingTime && /* @__PURE__ */ o(j, { text: n.waitingTime })
          ] })
        ]
      }
    ),
    !s && /* @__PURE__ */ i(z, { children: [
      /* @__PURE__ */ o(j, { text: `${String(e("FARE"))} ${n.fare.title}` }),
      /* @__PURE__ */ o(oe, { textShow: e("FARE_DETAILS_COLLAPSED"), textHide: e("FARE_DETAILS_HIDE"), children: n.fare.items.map((_) => /* @__PURE__ */ o(j, { icon: at(_.code), text: _.title, children: /* @__PURE__ */ o(T, { text: _.text }) }, _.code)) })
    ] })
  ] });
}, ie = (t) => {
  const { t: e } = h("summary"), { fragment: n, route: r, routeCode: a, destinationCity: s, collapsed: _ = !1 } = t, { date: p, airport: x, terminal: f, cabin: I } = n;
  return /* @__PURE__ */ i(
    j,
    {
      text: s ? `${String(e("ARRIVAL"))} ${s}` : _ ? a : r,
      children: [
        /* @__PURE__ */ o(T, { text: p }),
        !_ && /* @__PURE__ */ i(S, { children: [
          /* @__PURE__ */ o(T, { text: x }),
          /* @__PURE__ */ o(T, { text: `${e("SUMMARY_TERMINAL")}  ${f}` }),
          I && /* @__PURE__ */ o(T, { text: `${String(e("CABIN"))}  ${I}` })
        ] })
      ]
    }
  );
}, st = (t) => {
  const [e] = te({
    overThresholdCollapsed: t.collapsed ?? !1,
    underThresholdCollapsed: t.collapsed ?? !0
  });
  return e ? /* @__PURE__ */ o(it, { ...t }) : /* @__PURE__ */ o(lt, { ...t });
}, it = (t) => {
  const { t: e } = h("summary"), { trips: n, stopover: r, title: a } = t;
  return /* @__PURE__ */ i(m, { className: b(c.summary_collapsed, c.summary_back), children: [
    /* @__PURE__ */ o(z, { title: a ?? e("SUMMARY_TITLE") }),
    n == null ? void 0 : n.map((s, _) => /* @__PURE__ */ o(he, { trip: s, indexTrip: _, stopover: r, collapsed: !0 }, s.id)),
    /* @__PURE__ */ o(m, { className: c.summary_accordion, children: /* @__PURE__ */ o(oe, { textShow: "", textHide: "", triggerPosition: "top", children: /* @__PURE__ */ o(m, { className: c.summary, children: /* @__PURE__ */ o(fe, { ...t }) }) }) })
  ] });
}, lt = (t) => {
  const { t: e } = h("summary");
  return /* @__PURE__ */ i(m, { className: b(c.summary, c.summary_back), children: [
    /* @__PURE__ */ o(z, { title: t.title ?? e("SUMMARY_TITLE") }),
    /* @__PURE__ */ o(fe, { ...t })
  ] });
}, fe = (t) => {
  const { t: e } = h("summary"), {
    trips: n,
    stopover: r,
    passengers: a,
    ancillaries: s,
    otherItems: _,
    onholdPrice: p,
    avios: x,
    totalPrice: f,
    totalDcc: I,
    upgradingBid: A,
    collapsed: H,
    nemuru: O
  } = t;
  return /* @__PURE__ */ i(S, { children: [
    n == null ? void 0 : n.map((d, $) => /* @__PURE__ */ o(he, { trip: d, indexTrip: $, stopover: r, collapsed: !1 }, d.id)),
    a && /* @__PURE__ */ o(
      z,
      {
        title: e("PASSENGERS"),
        total: {
          title: e("HEADER_FLIGHTS_TOTAL"),
          price: a.total
        },
        children: a.types.map((d) => /* @__PURE__ */ o(tt, { passenger: d, onClick: a.onClick }, d.type))
      }
    ),
    s == null ? void 0 : s.map((d) => /* @__PURE__ */ o(ot, { ancillarie: d }, d.code)),
    _ == null ? void 0 : _.map((d) => {
      var Q;
      let $ = "", P = "";
      return d.type !== "ONHOLD" && d.type !== "JOURNEY" && ($ = e(`OTHER_ITEMS_${d.type}`)), d.type !== "ONHOLD" && d.type !== "JOURNEY" && d.type !== "OFFERS" && (P = e(`OTHER_ITEMS_TOTAL_${d.type}`)), /* @__PURE__ */ o(
        z,
        {
          title: $,
          total: d.total ? {
            title: P,
            price: d.total
          } : void 0,
          children: /* @__PURE__ */ o(j, { text: d.subtitle, price: d.price, children: (Q = d.items) == null ? void 0 : Q.map((R) => /* @__PURE__ */ o(
            T,
            {
              amount: R.amount,
              text: R.description,
              price: R.price
            },
            R.code
          )) })
        },
        d.type
      );
    }),
    /* @__PURE__ */ o(
      nt,
      {
        title: e(A ? "MAX_TO_PAY" : "TOTAL"),
        subtitle: A && e("UPGRADING_BIDS_PAYMENT") || p && e("TOTAL_ONHOLD_SUBTITLE"),
        price: p || f,
        avios: x,
        dccPrice: I
      }
    ),
    O && !H && /* @__PURE__ */ o(pt, { quotes: O.quotes, price: O.price, onChange: O.onChange })
  ] });
}, Cr = M(st), ct = "_nemuru_content_9whxo_1", _t = "_nemuru_icon_9whxo_6", mt = "_nemuru_select_9whxo_11", dt = "_nemuru_text_9whxo_16", K = {
  nemuru_content: ct,
  nemuru_icon: _t,
  nemuru_select: mt,
  nemuru_text: dt
}, ut = (t) => {
  const { quotes: e, onChange: n } = t;
  return /* @__PURE__ */ o(
    "select",
    {
      defaultValue: e.at(-1),
      className: K.nemuru_select,
      name: "quotes-select",
      "data-testid": "quotes-select",
      onChange: (r) => {
        n(parseInt(r.target.value));
      },
      children: e.map((r) => /* @__PURE__ */ o("option", { value: r, "data-testid": `option-quote-${String(r)}`, children: r }, `option-quote-${String(r)}`))
    }
  );
}, pt = (t) => {
  const { t: e } = h("nemuru"), { quotes: n, onChange: r, price: a } = t;
  return /* @__PURE__ */ i(m, { className: K.nemuru_content, children: [
    /* @__PURE__ */ o(C, { className: K.nemuru_icon, color: "#D7192D", name: "pago-cuotas" }),
    /* @__PURE__ */ o(l, { className: K.nemuru_text, font: "verdana", size: "md-regular", children: /* @__PURE__ */ o(
      Ae,
      {
        defaults: e("BANNER_QUOTAS_NEMURU_TEXT_2", { price: a }),
        components: [/* @__PURE__ */ o(ut, { quotes: n, onChange: r }, "quotes-select-component")]
      }
    ) })
  ] });
}, bt = "_alert_container_fqey6_1", gt = "_alert_header_fqey6_11", ht = "_alert_description_fqey6_20", ft = "_alert_icon_fqey6_26", yt = "_alert_warning_fqey6_31", Nt = "_alert_title_fqey6_34", xt = "_alert_error_fqey6_42", Tt = "_alert_info_fqey6_46", D = {
  alert_container: bt,
  alert_header: gt,
  alert_description: ht,
  alert_icon: ft,
  alert_warning: yt,
  alert_title: Nt,
  alert_error: xt,
  alert_info: Tt
}, Ct = (t) => {
  const { t: e } = h(["alert-upgrading-avios", "common"]), { id: n, type: r = "alert_warning" } = t, a = g.useId(), s = n ?? a;
  return /* @__PURE__ */ i(
    "section",
    {
      role: "alert",
      className: y(D.alert_container, D[r]),
      id: `${s}-alert-upgrading-avios`,
      children: [
        /* @__PURE__ */ i("header", { className: D.alert_header, children: [
          /* @__PURE__ */ o(C, { name: "alertas", className: D.alert_icon }),
          /* @__PURE__ */ o(l, { className: y(D.alert_title, D[r]), as: "h3", font: "iberia-headline", size: "xs-regular", children: e("common:IMPORTANT_ANNOUNCEMENT") })
        ] }),
        /* @__PURE__ */ o(l, { font: "verdana", size: "lg-regular", className: D.alert_description, children: e("MMB_UPGRADING_AVIOS_ALERT_INFO_2") })
      ]
    }
  );
}, vr = M(Ct), vt = "_alert_container_ofyrq_1", It = "_alert_header_ofyrq_11", Et = "_alert_description_ofyrq_18", Ot = "_alert_icon_ofyrq_23", At = "_error_ofyrq_27", Rt = "_info_ofyrq_31", k = {
  alert_container: vt,
  alert_header: It,
  alert_description: Et,
  alert_icon: Ot,
  error: At,
  info: Rt,
  "alert-title": "_alert-title_ofyrq_33"
}, jt = (t) => {
  const { t: e } = h(["alert-upgrading-bids", "common"]), { id: n, type: r = "alert_info" } = t, a = g.useId(), s = n ?? a;
  return /* @__PURE__ */ i("section", { role: "alert", className: y(k.alert_container), id: `${s}-alert-upgrading-bids`, children: [
    /* @__PURE__ */ i("header", { className: k.alert_header, children: [
      /* @__PURE__ */ o(C, { name: "informacion_2", className: k.alert_icon }),
      /* @__PURE__ */ o(l, { className: y(k.alert__title, k[r]), as: "h3", font: "iberia-headline", size: "xs-regular", children: e("common:IMPORTANT_ANNOUNCEMENT") })
    ] }),
    /* @__PURE__ */ o(l, { font: "verdana", size: "lg-regular", className: k.alert_description, children: e("UPGRADING_BIDS_PAYMENT_INFO_TEXT") })
  ] });
}, Ir = M(jt), wt = "_box_container_1urbe_1", St = "_box_heading_1urbe_14", Lt = "_box_collapsible_1urbe_21", Ht = "_box_title_1urbe_27", $t = "_box_icon_collapsable_1urbe_31", Dt = "_box_content_1urbe_35", qt = "_box_form_1urbe_42", zt = "_box_button_1urbe_49", Pt = "_box_link_1urbe_54", kt = "_box_input_icon_response_1urbe_59", Ut = "_box_input_message_box_1urbe_67", Ft = "_box_input_icon_1urbe_59", Bt = "_box_input_text_1urbe_90", Mt = "_box_input_subtext_1urbe_96", Xt = "_box_loading_1urbe_101", N = {
  box_container: wt,
  box_heading: St,
  box_collapsible: Lt,
  box_title: Ht,
  box_icon_collapsable: $t,
  box_content: Dt,
  box_form: qt,
  box_button: zt,
  box_link: Pt,
  box_input_icon_response: kt,
  box_input_message_box: Ut,
  box_input_icon: Ft,
  box_input_text: Bt,
  box_input_subtext: Mt,
  box_loading: Xt
}, Vt = (t) => {
  const { t: e } = h(["voucher", "common"]), { discount: n, remainingAmount: r, isRemainingAmountZero: a } = t;
  return /* @__PURE__ */ i("div", { className: N.box_input_message_box, children: [
    /* @__PURE__ */ i("div", { className: N.box_input_icon_response, children: [
      /* @__PURE__ */ o("span", { className: N.box_input_icon, children: /* @__PURE__ */ o(C, { name: "confirmacion" }) }),
      /* @__PURE__ */ o(l, { as: "span", font: "verdana", className: N.box_input_text, children: `${e("DISCCOUNT_TEXT")}: ${n ?? ""}` })
    ] }),
    r && r.length > 0 && /* @__PURE__ */ o(l, { as: "span", font: "verdana", className: N.box_input_subtext, children: a ? e("ERROR_NO_AMOUNT") : `${e("SUCCESS_1")} ${r} ${e("SUCCESS_2")}` })
  ] });
};
function Gt() {
  var $;
  const { handleClick: t, setLoading: e, value: n } = xe(ye), [r, a] = B(n ?? { status: !1 }), { t: s } = h(["voucher", "common"]), {
    register: _,
    handleSubmit: p,
    formState: { errors: x },
    setError: f,
    reset: I
  } = Le();
  q(() => {
    r.message && f("voucherCode", { message: r.message });
  }, [r]), q(() => {
    a(n ?? { status: !1 });
  }, [n]);
  const A = async (P, Q) => {
    try {
      e(!0);
      const R = await t(P, Q);
      R && a(R), e(!1);
    } catch (R) {
      console.error("Error submitting form:", R);
    }
  }, H = async () => {
    e(!0), await t("", !0), a({ status: !1 }), I(), e(!1);
  }, O = async (P) => {
    r.status ? await H() : await A(P.voucherCode, !1);
  }, d = () => r.isPartner ? s("DELETE_BUTTON_FOR_DUMBO") : r.status ? s("DELETE_BUTTON") : s("common:APPLY_TEXT");
  return /* @__PURE__ */ o("form", { onSubmit: p(O), children: /* @__PURE__ */ i("div", { className: N.box_form, children: [
    r.status ? /* @__PURE__ */ o(Vt, { ...r }) : /* @__PURE__ */ o(
      Re,
      {
        id: "voucherCode",
        errorMessage: ($ = x.voucherCode) == null ? void 0 : $.message,
        ..._("voucherCode", {
          required: s("common:INPUT_REQUIRED_ERROR"),
          maxLength: 50
        }),
        label: s("PLACEHOLDER")
      }
    ),
    /* @__PURE__ */ o(
      ve,
      {
        type: "submit",
        variant: "primary",
        buttonSize: "small",
        className: N.box_button,
        "data-testid": "voucher-button",
        children: d()
      }
    )
  ] }) });
}
const ye = Te({
  handleClick: async () => Promise.resolve({ status: !1 }),
  setLoading: () => {
  },
  value: { status: !1 }
}), Wt = ({ id: t, value: e, handleClick: n, urlLink: r }) => {
  const { t: a } = h(["voucher", "common"]), [s, _] = te({
    overThresholdCollapsed: !1,
    underThresholdCollapsed: !1
  }), [p, x] = B(!1);
  return /* @__PURE__ */ o(ye.Provider, { value: { setLoading: x, handleClick: n, value: e }, children: /* @__PURE__ */ i(m, { id: t, className: N.box_container, children: [
    p && /* @__PURE__ */ o(ue, { size: "big", className: N.box_loading, children: a("common:LOADING_TEXT") }),
    /* @__PURE__ */ i("div", { className: N.box_heading, children: [
      /* @__PURE__ */ o(l, { as: "h4", font: "iberia-headline", size: "xs-regular", className: N.box_title, children: a("TITLE") }),
      /* @__PURE__ */ o(
        "button",
        {
          "data-testid": "voucher-collapsible",
          className: N.box_collapsible,
          onClick: () => {
            _((f) => !f);
          },
          children: /* @__PURE__ */ o(
            C,
            {
              name: s ? "chevron-line-up" : "chevron-line-down",
              className: N.box_icon_collapsable,
              size: s ? 16 : 18
            }
          )
        }
      )
    ] }),
    !s && /* @__PURE__ */ i("div", { className: N.box_content, children: [
      /* @__PURE__ */ o(Gt, {}),
      /* @__PURE__ */ o(Ie, { link: r, className: N.box_link, target: "__blank", children: a("common:TERMS_AND_CONDITIONS_TEXT") })
    ] })
  ] }) });
}, Er = M(Wt);
export {
  w as A,
  m as B,
  ir as C,
  ue as L,
  pt as N,
  xr as O,
  lr as P,
  mr as S,
  dr as T,
  po as V,
  Ve as a,
  de as b,
  Ge as c,
  cr as d,
  io as e,
  _r as f,
  pr as g,
  ur as h,
  br as i,
  gr as j,
  hr as k,
  fr as l,
  yr as m,
  Nr as n,
  Tr as o,
  Cr as p,
  vr as q,
  Ir as r,
  Er as s
};
